module.exports = __webpack_public_path__ + "img/videos-capa.cf5e2162.webp";